import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.702 12.734c0-1.024-.083-1.772-.263-2.547H12.743v4.623h6.865c-.138 1.149-.885 2.879-2.546 4.042l-.024.154 3.698 2.865.257.026c2.353-2.173 3.71-5.37 3.71-9.163"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.743 24.914c3.364 0 6.187-1.107 8.25-3.017l-3.931-3.045c-1.052.733-2.464 1.245-4.319 1.245-3.294 0-6.09-2.173-7.086-5.176l-.147.012-3.845 2.976-.05.14c2.048 4.07 6.256 6.865 11.128 6.865"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.657 14.92a7.7 7.7 0 0 1-.416-2.463c0-.858.153-1.689.402-2.464l-.007-.165-3.894-3.023-.127.06a12.5 12.5 0 0 0-1.329 5.592c0 2.007.485 3.903 1.329 5.592z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.743 4.817c2.34 0 3.917 1.01 4.817 1.854l3.516-3.432C18.916 1.232 16.106 0 12.743 0 7.871 0 3.663 2.796 1.615 6.865l4.028 3.128c1.01-3.003 3.806-5.176 7.1-5.176"
    }, null, -1)
  ]))]))
}
export default { render: render }